import { render, staticRenderFns } from "./dataHook.vue?vue&type=template&id=995ddc82&"
import script from "./dataHook.vue?vue&type=script&lang=js&"
export * from "./dataHook.vue?vue&type=script&lang=js&"
import style0 from "./dataHook.vue?vue&type=style&index=0&id=995ddc82&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports